import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { adminRouts } from "../../Constants";
import './admin.scss'

const Admin = () => (
    <div id={'adminPage'}>
        <Switch>
            {adminRouts.map((route, index) =>
                <Route key={index} path={route.path} component={route.component} exact={route.exact}/>
            )}
            <Redirect to={'/admin/home'} />
        </Switch>
    </div>
);

export default Admin;
